export default "__VITE_ASSET__Ber1mwCT__"